import { AnyAction } from 'redux';

import { IReducer } from '../interfaces/IReducer';

export interface IActionReducerFactory<TState> {
    (actionType: string, reducer: IReducer<TState>): IReducer<TState>;
}

export function createNamespaceReducerFactory<TState> (namespace: string): IActionReducerFactory<TState> {
    return (actionType: string, reducer: IReducer<TState>): IReducer<TState> => {
        return (state: TState, action: AnyAction): void => {
            if (
                action &&
                (action.namespace !== namespace || action.type !== actionType)
            ) {
                return;
            }

            reducer(state, action);
        };
    };
}